// @flow
import React from 'react';
import styled from '@emotion/styled';

import ChallengeInfoTab from 'app/components/challenge/ChallengeInfoTab';
import LightTabSet from 'app/components/commons/LightTabSet';
import MenuWrapper from 'app/components/commons/MenuWrapper';

import TabContent from './TabContent';

type Props = {
  slateId?: string | number,
  activeTab?: string,
  onClose: () => void,
  bonuses?: Object,
  labels?: Array<Object>,
  activeSettingsTab: string,
  sportHasTeam?: boolean,
  useAverage?: boolean,
  scheme?: 'light' | 'dark' | 'white',
  onSelect: (tab: string) => void,
  onSelectSettingsTab: (tab: string) => void,
  tabs: Array<Object>
};

const defaultProps = {
  sportHasTeam: true,
  useAverage: false,
  slateId: undefined,
  activeTab: undefined,
  bonuses: undefined,
  labels: [],
  scheme: 'light'
};

const Wrapper = styled.div(
  ({ theme }) => ({
    [theme.mediaQuery.desktopAndUp]: {
      fontSize: theme.fontSize.xsmall
    }
  }),
  ({ theme, scheme }) =>
    ({
      white: {
        backgroundColor: theme.color.white,
        color: theme.color.basis1
      },
      light: {
        color: theme.color.basis1
      },
      dark: {
        color: theme.color.white
      }
    }[scheme])
);

const NavWrapper = styled.div(
  {
    display: 'flex',
    position: 'relative'
  },
  ({ theme }) => ({
    backgroundColor: theme.color.basis6,
    justifyContent: 'center'
  })
);

const TabContainer = styled.div({
  width: '100%',
  maxWidth: 120 * 6
});

const Tabs = ({
  activeTab,
  bonuses,
  activeSettingsTab,
  sportHasTeam,
  useAverage,
  onSelect,
  onClose,
  slateId,
  tabs,
  labels,
  scheme,
  onSelectSettingsTab
}: Props) => {
  return (
    <Wrapper scheme={scheme}>
      <NavWrapper>
        <TabContainer>
          <MenuWrapper component={LightTabSet} activeProp="active" value={activeTab}>
            {tabs.map(({ id, label }) => (
              <ChallengeInfoTab key={id} id={id} onSelect={() => onSelect(id)}>
                {label}
              </ChallengeInfoTab>
            ))}
          </MenuWrapper>
        </TabContainer>
      </NavWrapper>
      {!!activeTab && (
        <TabContent
          activeTabItem={activeTab}
          bonuses={bonuses}
          labels={labels}
          sportHasTeam={sportHasTeam}
          useAverage={useAverage}
          onClose={onClose}
          activeSettingsTab={activeSettingsTab}
          onSelectSettingsTab={onSelectSettingsTab}
          slateId={slateId}
          scheme={scheme}
        />
      )}
    </Wrapper>
  );
};

Tabs.defaultProps = defaultProps;

export default React.memo(Tabs);
